import React from 'react';
import InformationsUtiles from '../components/InformationsUtiles';
import './InfosUtiles.css';

const InfosUtiles = () => {
  return (
    <div className="infos-utiles-page">
      <section className="infos-utiles-hero">
        <div className="container">
          <h1 className="infos-utiles-title">Informations utiles</h1>
        </div>
      </section>
      <InformationsUtiles />
    </div>
  );
};

export default InfosUtiles;
